import {
  GET_ADMINS_LIST_FAILURE,
  GET_ADMINS_LIST_STARTED,
  GET_ADMINS_LIST_SUCCESS,
  SEND_NEW_MAIL_FAILURE,
  SEND_NEW_MAIL_STARTED,
  SEND_NEW_MAIL_SUCCESS,
  SET_Admin,
} from "redux/ActionTypes";
// --------------------------------------------------------------------------------
const initialState = {
  rType: null,
  adminList: [],
  selectedAdmin: 0,
  error: "",
};
export const AdminReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADMINS_LIST_STARTED:
    case SEND_NEW_MAIL_STARTED:
      return {
        ...state,
        rType: action.type,
        error: "",
      };
    case SEND_NEW_MAIL_SUCCESS:
      return {
        ...state,
        rType: SEND_NEW_MAIL_SUCCESS,
        error: "",
      };
    case GET_ADMINS_LIST_SUCCESS:
      return {
        ...state,
        rType: GET_ADMINS_LIST_SUCCESS,
        adminList: action.payload.adminList.map((admin) => ({
          ...admin,
          name: `${admin.first_name} ${admin.last_name}`,
        })),
        error: "",
      };
    case GET_ADMINS_LIST_FAILURE:
    case SEND_NEW_MAIL_FAILURE:
      return {
        ...state,
        rType: action.type,
        error: action.payload,
      };
    case SET_Admin:
      return {
        ...state,
        selectedAdmin: action.payload,
      };
    default:
      return state;
  }
};
